/**
 * Warehouse Gallery - Splide Carousel Initialization
 * Handles the main image slider and thumbnail navigation
 */

class WarehouseGallery {
    constructor() {
        this.modal = null;
        this.mainSlider = null;
        this.thumbnailSlider = null;
        this.isInitialized = false;
        
        this.init();
    }
    
    init() {
        document.addEventListener('alpine:init', () => {
            this.setupModalObserver();
        });
    }
    
    setupModalObserver() {
        this.modal = document.querySelector('[x-show="showModal"]');
        if (!this.modal) return;
        
        // Initialize sliders when modal becomes visible
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const isVisible = this.modal.style.display !== 'none';
                    if (isVisible && !this.isInitialized) {
                        setTimeout(() => this.initializeSliders(), 100);
                    }
                }
            });
        });
        
        observer.observe(this.modal, { attributes: true });
    }
    
    initializeSliders() {
        const mainSliderElement = document.querySelector('#main-slider');
        const thumbnailSliderElement = document.querySelector('#thumbnail-slider');
        
        if (!mainSliderElement || mainSliderElement.splide) return;
        
        try {
            // Initialize main slider
            this.mainSlider = new window.Splide('#main-slider', {
                type: 'fade',
                rewind: true,
                pagination: false,
                arrows: true,
            });
            
            // Initialize thumbnail slider if it exists
            if (thumbnailSliderElement) {
                this.thumbnailSlider = new window.Splide('#thumbnail-slider', {
                    fixedWidth: 80,
                    fixedHeight: 60,
                    gap: 8,
                    rewind: true,
                    pagination: false,
                    arrows: false,
                    cover: true,
                    isNavigation: true,
                    focus: 'center',
                    breakpoints: {
                        600: {
                            fixedWidth: 60,
                            fixedHeight: 45,
                        },
                    },
                });
                
                // Sync sliders
                this.mainSlider.sync(this.thumbnailSlider);
                this.mainSlider.mount();
                this.thumbnailSlider.mount();
            } else {
                this.mainSlider.mount();
            }
            
            this.isInitialized = true;
            
        } catch (error) {
            console.error('Error initializing warehouse gallery sliders:', error);
        }
    }
    
    destroy() {
        if (this.mainSlider) {
            this.mainSlider.destroy();
            this.mainSlider = null;
        }
        if (this.thumbnailSlider) {
            this.thumbnailSlider.destroy();
            this.thumbnailSlider = null;
        }
        this.isInitialized = false;
    }
}

// Initialize when DOM is ready
if (typeof window !== 'undefined') {
    new WarehouseGallery();
}

export default WarehouseGallery;
